module.exports = __webpack_public_path__ + "static/media/subscribe-now.5b4f3fd8.png";